import { Accordion, ScrollArea, Text } from "@mantine/core";
import { AttendeeItem } from "./AttendeeItem";
import { AttendeesListProps } from "./types";

export const AttendeesList = ({
  attendees,
  stagedRequests,
  eventStartTime,
  eventLocationName,
  onRemoveStaged,
  onChangeRequest,
  onCancel,
}: AttendeesListProps) => {
  return (
    <ScrollArea style={{ height: "100%" }}>
      <Accordion multiple>
        {/* Confirmed attendees */}
        {attendees.map((attendee) => (
          <AttendeeItem
            key={attendee.id}
            request={attendee}
            eventStartTime={eventStartTime}
            eventLocationName={eventLocationName}
            isStaging={false}
            onChangeRequest={onChangeRequest}
            onCancel={onCancel}
          />
        ))}

        {/* Staged requests */}
        {stagedRequests.map((request) => (
          <AttendeeItem
            key={`staged-${request.id}`}
            request={request}
            eventStartTime={eventStartTime}
            eventLocationName={eventLocationName}
            isStaging={true}
            onRemove={onRemoveStaged}
          />
        ))}
      </Accordion>

      {attendees.length === 0 && stagedRequests.length === 0 && (
        <Text c="gray" size="sm" ta="center" p="md">
          참석자가 없습니다
        </Text>
      )}
    </ScrollArea>
  );
};
